import { createFileRoute } from '@tanstack/react-router';
import { AdminEventPage } from '../../features/community';

export const Route = createFileRoute('/admin/community/events/$id')({
  component: function AdminEventRoute() {
    const { id } = Route.useParams();
    return <AdminEventPage id={id} />;
  },
});
